enum PinataTableTrackerRequestType {
  Jtech = 'jtech',
  Lrs = 'lrs',
}

export { PinataTableTrackerRequestType };
